"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysToGenerate = void 0;
var getOrdersByArticlesByDays_1 = require("./getOrdersByArticlesByDays");
var getResuppliesByArticlesByDays_1 = require("./getResuppliesByArticlesByDays");
var moment_1 = __importDefault(require("moment"));
function getDaysToGenerate(from, supplies, resupplies) {
    var res1 = getOrdersByArticlesByDays_1.getOrdersByArticlesByDays(supplies);
    var res2 = resupplies
        ? getResuppliesByArticlesByDays_1.getResuppliesByArticlesByDays(resupplies)
        : {
            maxDateKey: "2000-01-01",
            resuppliesByArticleByDay: {},
        };
    var maxDateKey = res1.maxDateKey > res2.maxDateKey ? res1.maxDateKey : res2.maxDateKey;
    var daysToGenerate = moment_1.default(maxDateKey).diff(from, "days") + 3;
    if (daysToGenerate < 7)
        daysToGenerate = 7;
    return daysToGenerate;
}
exports.getDaysToGenerate = getDaysToGenerate;
